import { FC } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import Button from "@/components/Button";

const Wrap = styled.div`
  background: ${({ theme }) => theme.colors.grayscaleLight};
  text-align: center;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${Text} {
    margin-bottom: 30px;
  }
`;

const NotFound: FC<{ global?: boolean }> = ({ global = false }) => {
  if (global) {
    return (
      <Wrap>
        <Text $type="heading1">Page Not Found</Text>
        <Button as={Link} to="/">
          Back to Homepage
        </Button>
      </Wrap>
    );
  }
  return (
    <>
      <TeamHeading>404</TeamHeading>
      <PageHeading>Page Not Found</PageHeading>
    </>
  );
};

export default NotFound;
